import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import { Stack } from '@mui/material';

import useSubscribeRefresh  from 'use-subscribe-actions'
import TableSkeleton from 'components/global/CUK/Skeletons/TableSkeleton'
import MainContent, { ResponsiveSideContent, TableContent } from 'components-shared';
import EmptyScreen from 'packages/ui/EmptyScreen';
import { ResponsiveTableProvider } from 'packages/ui/Table';

import AudinTable from './Table/AudinTable';
import Filters from '../Filters';
import Card from './Card/Card';
import useAudinDocuments from '../hooks/use-audin-documents';
import useFilters from '../store';
import useCount from '../hooks/use-count';

const AudinDocuments = () => {
  const [document, setDocument] = useState(null);
  const apiDocuments = useAudinDocuments();
  const [filters] = useFilters();
  const apiCount = useCount();
  const { t } = useTranslation();
  const navigate = useNavigate();
  useSubscribeRefresh(() => navigate('/documents/audin'));

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  const formattedDocuments = useMemo(() => {
    if (!apiDocuments.documents) return [];
    return apiDocuments.documents.map(doc => ({
      ...doc,
      created_at: formatDate(doc.created_at),
      updated_at: formatDate(doc.updated_at),
    }));
  }, [apiDocuments.documents]);

  useEffect(() => {
    apiDocuments.refetch();
  }, [filters]);

  const handleRowClick = (doc) => {
    setDocument(doc);
  };

  return (
    <Stack flex={1}>
      <Filters apiCount={apiCount} />
      <MainContent>
        <TableContent>
          <ResponsiveTableProvider>
            {apiDocuments.loading ? (
              <TableSkeleton />
            ) : !apiDocuments.documents || apiDocuments.documents.length === 0 || apiDocuments.error ? (
              <EmptyScreen icon="file">{t('documents.no_documents_filter')}</EmptyScreen>
            ) : (
              <AudinTable
                documentSelected={document}
                apiDocuments={{
                  ...apiDocuments,
                  documents: formattedDocuments,
                }}
                onRowClick={handleRowClick}
              />
            )}
          </ResponsiveTableProvider>
        </TableContent>
        {Boolean(document) && (
          <ResponsiveSideContent onClose={() => setDocument(null)}>
            <Card data={document} onClose={() => setDocument(null)} />
          </ResponsiveSideContent>
        )}
      </MainContent>
    </Stack>
  );
};

export default AudinDocuments;
